var map = {
	"./about-card.de-CH.json": 1394,
	"./about-card.de-DE.json": 1395,
	"./about-card.en-CA.json": 1396,
	"./about-card.en-GB.json": 1397,
	"./about-card.en-IN.json": 1398,
	"./about-card.en-ME.json": 1399,
	"./about-card.en-US.json": 1400,
	"./about-card.es-EM.json": 1401,
	"./about-card.es-ES.json": 1402,
	"./about-card.fr-BE.json": 1403,
	"./about-card.fr-CA.json": 1404,
	"./about-card.fr-CH.json": 1405,
	"./about-card.nl-BE.json": 1406,
	"./about-card.nl-NL.json": 1407,
	"./about-card.pl-PL.json": 1408,
	"./about-card.pt-BR.json": 1409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;